import styled from "styled-components"

export const SocialsStyles = styled.div`
  &.social__menu {

    ul {
      display: flex;
      list-style: none;
      align-content: center;

      @media (min-width: 768px) {
        flex-direction: row;
        justify-content: flex-end;
      }

      li {
        font-size: var(--h6);
        margin-right: var(--borderSpacing-small);

        @media (min-width: 768px) {
          margin-left: 10px;
          margin-right: 10px;
        }

        a {
          color: var(--light-colour);
          font-size: 2.2rem;
        }

        &:hover,
        &:focus {
          a {
            color: var(--brand-yellow);
          }
        }
      }
    }
  }
`
